module.exports = __webpack_public_path__ + "media/trucks/pickup-752709fe.svg";